import { IconArrowLeft } from './vsj-icons';

interface VsjStepHeaderProps {
  step: 1 | 2 | 3 | 4;
  onBack: () => void;
  /** Transparent gradient variant for screens where the map is the background. */
  overlay?: boolean;
}

export function VsjStepHeader({ step, onBack, overlay = false }: VsjStepHeaderProps) {
  return (
    <header className={'vsj-step-header' + (overlay ? ' vsj-step-header--overlay' : '')}>
      <button className="vsj-back-btn" onClick={onBack} aria-label="Volver">
        <IconArrowLeft size={22} />
      </button>
      <div className="vsj-progress-dots" aria-label={`Paso ${step} de 4`}>
        {[1, 2, 3, 4].map((n) => (
          <span
            key={n}
            className={
              'vsj-progress-dot' +
              (n === step ? ' vsj-progress-dot--active' : '') +
              (n < step  ? ' vsj-progress-dot--done'   : '')
            }
          />
        ))}
      </div>
    </header>
  );
}
